import React from 'react';

const SingleSection = ({ section, onChange }) => {
    const options = [
        { label: "S1 - Site", value: "S1 - Site" },
        { label: "S2 - Site", value: "S2 - Site" },
        { label: "S1 - CY", value: "S1 - CY" },
        { label: "S2 - CY", value: "S2 - CY" },
        { label: "S1 - Er", value: "S1 - Er" },
        { label: "S2 - Er", value: "S2 - Er" },
      ];

  return (
    <div>
      <label htmlFor="section-dropdown" className="block mb-2 font-medium">
        Select Section
      </label>
      <select
        id="section-dropdown"
        className="p-2 border border-gray-300 rounded shadow-sm w-full"
        value={section}
        onChange={onChange}
      >
        <option value="" disabled>
          -- Select a section --
        </option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SingleSection;
